"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectHasProperties = void 0;
/**
 * Checks if an object has properties.
 *
 * @public
 * @param obj - The object to check.
 * @returns True if the object has properties.
 *
 * @example
 * ```ts
 * const result = hasProperties({});
 * console.log(result);
 * // -> false
 * ```
 */
function objectHasProperties(obj) {
    return Object.keys(obj).length > 0;
}
exports.objectHasProperties = objectHasProperties;
//# sourceMappingURL=object-has-properties.js.map